import React, { useEffect, useState, useRef, useMemo } from 'react';
import {
  Button, Select, MenuItem, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Container, Grid, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, Tooltip, Checkbox,
  IconButton,
  Box, Stack, Chip, Divider, useMediaQuery, Switch, FormControlLabel
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
// Optionally, to apply standard dark-mode defaults:
import { CssBaseline } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNotification } from './context/NotificationContext';

const App = () => {
  const { showNotification } = useNotification();
  const baseUrl = 'https://frek.cc/proxy/38.54.86.24:7687';
  const [mediaStats, setMediaStats] = useState([]);
  const [prevTxPackets, setPrevTxPackets] = useState({});
  const [prevRxPackets, setPrevRxPackets] = useState({});
  const [rxPktColor, setRxPktColor] = useState({});
  const [txPktColor, setTxPktColor] = useState({});
  const txTimeoutRef = useRef({});
  const rxTimeoutRef = useRef({});
  const [openPortRestartDialog, setOpenPortRestartDialog] = useState(false);
  const [portToRestart, setPortToRestart] = useState(null);
  const [callStats, setCallStats] = useState([]);
  const [sipStats, setSipStats] = useState([]);
  const [portStats, setPortStats] = useState([]);
  const [ussdStats, setUssdStats] = useState([]);
  const [selectedGateway, setSelectedGateway] = useState(localStorage.getItem('selectedGateway') || 'g1');
  const gateways = ['g1', 'g2', 'g3', 'g4', 'g5', 'g6', 'g7', 'g8'];
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openUssdDialog, setOpenUssdDialog] = useState(false);
  const [operationInProgress, setOperationInProgress] = useState(false);
  const [selectedPorts, setSelectedPorts] = useState([]);
  const [selectedUssdPorts, setSelectedUssdPorts] = useState([]);
  const [ussdGlobalCommand, setUssdGlobalCommand] = useState('');
  const [ussdLoading, setUssdLoading] = useState(false);
  const [ussdSubmitting, setUssdSubmitting] = useState(false);
  const [ussdConfirmState, setUssdConfirmState] = useState({
    open: false,
    mode: 'bulk',
    gatewayId: '',
    port: null,
    ports: [],
    commandPreview: '',
  });
  const [showAllUssdResponses, setShowAllUssdResponses] = useState(false);
  const [ussdClearing, setUssdClearing] = useState(false);
  const [simSwitchEnabled, setSimSwitchEnabled] = useState(false);
  const [simSwitchOperationInProgress, setSimSwitchOperationInProgress] = useState(false);
  const [formValues, setFormValues] = useState({
    esn_server_type: '',
    esn_server: '',
    esn_ucp_tcp: '',
    esn_username: '',
    esn_password: ''
  });
  const isMobile = useMediaQuery('(max-width:600px)');


  // Handler for enabling or disabling SIM switching
  const handleSimSwitch = (gatewayId, action) => {
    setSimSwitchOperationInProgress(true);
    const url = `${baseUrl}/sim-switch/${gatewayId}/${action}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          handleNotification(data.message);
          setSimSwitchEnabled(action === "enable");
        } else {
          handleNotification(data.error || "Failed to update SIM switching", "error");
        }
      })
      .catch((error) => {
        console.error("Error updating SIM switching:", error);
        handleNotification(`Error updating SIM switching: ${error.message}`, "error");
      })
      .finally(() => setSimSwitchOperationInProgress(false));
  };


  const prefillOptions = {
    'WF G1': {
      esn_server_type: 1,
      esn_server: '43.249.30.190',
      esn_ucp_tcp: 1,
      esn_username: '0112-R0133-3-515',
      esn_password: '0112-R0133-3-515'
    },
    'WF G2': {
      esn_server_type: 1,
      esn_server: '43.249.30.190',
      esn_ucp_tcp: 1,
      esn_username: '0112-R0133-4-515',
      esn_password: '0112-R0133-4-515'
    },
    'WF G6': {
      esn_server_type: 1,
      esn_server: '43.249.30.190',
      esn_ucp_tcp: 1,
      esn_username: '0112-R0133-5-515',
      esn_password: '0112-R0133-5-515'
    },
    'YX G1': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim1',
      esn_password: 'NU629sim1'
    },
    'YX G2': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim2',
      esn_password: 'NU629sim2'
    },
    'YX G3': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim3',
      esn_password: 'NU629sim3'
    },
    'YX G4': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU6294',
      esn_password: 'NU6294'
    },
    'YX G5': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim5',
      esn_password: 'NU629sim5'
    },
    'YX G6': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim6',
      esn_password: 'NU629sim6'
    }
    ,
    'YX G7': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim7',
      esn_password: 'NU629sim7'
    },
    'YX G8': {
      esn_server_type: 1,
      esn_server: '38.55.19.20',
      esn_ucp_tcp: 0,
      esn_username: 'NU629sim8',
      esn_password: 'NU629sim8'
    }
  };
  const hasSetBlockedPorts = useRef(false);

  useEffect(() => {
    // If we haven't set blocked ports yet AND callStats is available, do it
    if (!hasSetBlockedPorts.current && callStats.length > 0) {
      const blockedPorts = callStats
        .filter(stat => stat.Description === 'Blocked by user')
        .map(stat => stat.Port);

      setSelectedPorts(blockedPorts);
      // Mark that we have set the blocked ports so we don't do it again
      hasSetBlockedPorts.current = true;
    }
  }, [callStats]);


  const handleSubmitPorts = () => {
    // Build a dictionary of form fields for all 32 ports
    const payload = {
      goip_cmd_port: '',
      btn_goip_port_hwattr: 'Submit'
    };

    for (let i = 1; i <= 32; i++) {
      const isSelected = selectedPorts.includes(i);
      payload[`port_enable(${i})`] = isSelected ? 'on' : 'off';
      payload[`goip_slot_selected(${i})`] = '1';
      payload[`goip_lockTheOperator(${i})`] = '0';
      payload[`input_vol(${i})`] = '0';
      payload[`output_vol(${i})`] = '12';
      payload[`balance(${i})`] = '0.00';
      payload[`tel_hot(${i})`] = '';
      payload[`unnum(${i})`] = '';
      payload[`busynum(${i})`] = '';
      payload[`nonum(${i})`] = '';
    }

    // Now POST to the new route
    const url = `${baseUrl}/update-ports/${selectedGateway}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        // Check if success or not
        // For example, data might have {message: "..."} or {error: "..."}
        if (data.message) {
          handleNotification(`Ports updated: ${data.message}`);
        } else {
          handleNotification(`Ports update error: ${data.error}`, 'error');
        }
      })
      .catch(error => {
        console.error('Error updating ports:', error);
        handleNotification(`Error updating ports: ${error.message}`, 'error');
      });
  };

  const handleShowPortRestartDialog = (port) => {
    setPortToRestart(port);
    setOpenPortRestartDialog(true);
  };


  const buildRestartPayload = (portToRestart, selectedPorts) => {
    const payload = {
      command: 'restart',
      goip_cmd_port: String(portToRestart),
      btn_goip_port_hwattr: 'Submit',
    };

    for (let i = 1; i <= 32; i++) {
      const isSelected = selectedPorts.includes(i);
      payload[`port_enable(${i})`] = isSelected ? 'on' : 'off';
      payload[`goip_slot_selected(${i})`] = '1';
      payload[`goip_lockTheOperator(${i})`] = '0';
      payload[`input_vol(${i})`] = '0';
      payload[`output_vol(${i})`] = '12';
      payload[`balance(${i})`] = '0.00';
      payload[`tel_hot(${i})`] = '';
      payload[`unnum(${i})`] = '';
      payload[`busynum(${i})`] = '';
      payload[`nonum(${i})`] = '';
    }

    return payload;
  };


  const handleConfirmPortRestart = () => {
    // 1. Close the dialog
    setOpenPortRestartDialog(false);

    // 2. Build the payload
    const payload = buildRestartPayload(portToRestart, selectedPorts);

    // 3. POST to /update-ports/<gateway_id>
    const url = `${baseUrl}/update-ports/${selectedGateway}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          handleNotification(
            `Successfully restarted port ${portToRestart}: ${data.message}`
          );
        } else {
          handleNotification(
            `Failed to restart port ${portToRestart}: ${data.error}`,
            'error'
          );
        }
      })
      .catch(error => {
        console.error('Error restarting port:', error);
        handleNotification(
          `Error restarting port ${portToRestart}: ${error.message}`,
          'error'
        );
      });
  };



  // 1. Create a dark theme
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#0b0b10',
        paper: '#15161b',
      },
      text: {
        primary: '#e8e9ee',
        secondary: 'rgba(255,255,255,0.65)',
      },
      primary: {
        main: '#90caf9',
      },
      secondary: {
        main: '#f48fb1',
      },
      success: {
        main: '#4caf50',
      },
      warning: {
        main: '#ffb74d',
      },
      error: {
        main: '#f44336',
      },
    },
  });

  const handlePrefillChange = (event) => {
    const selectedOption = event.target.value;
    if (selectedOption in prefillOptions) {
      setFormValues(prefillOptions[selectedOption]);
    }
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleFormSubmit = () => {
    const url = `${baseUrl}/eims_config/${selectedGateway}`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formValues)
    })
      .then(response => response.json())
      .then(data => {
        handleNotification(`EIMS Configuration Response: ${data.message || data.error}`);
        setOpenDialog(false);
      })
      .catch(error => {
        console.error('Error sending EIMS configuration:', error);
        handleNotification(`Failed to send EIMS configuration for ${selectedGateway}`);
      });
  };

  const normalizePorts = (data) => (
    Array.isArray(data)
      ? data.map((item) => ({ ...item, Port: parseInt(item.Port, 10) }))
      : []
  );

  const formatUssdResponse = (value) => String(value || '')
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n');

  const fetchUssdData = (gatewayId = selectedGateway, options = {}) => {
    const { silent = false } = options;
    if (!silent) {
      setUssdLoading(true);
    }

    return fetch(`${baseUrl}/monitor-ussd/${gatewayId}`)
      .then((response) => response.json())
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error(data?.error || 'Invalid USSD response');
        }

        const normalized = normalizePorts(data).map((item) => ({
          ...item,
          Response: formatUssdResponse(item.Response),
        }));
        setUssdStats(normalized);

        setSelectedUssdPorts((prevSelected) => {
          if (prevSelected.length > 0) {
            return prevSelected;
          }

          if (selectedPorts.length > 0) {
            return selectedPorts;
          }

          return normalized.map((item) => item.Port);
        });

        return normalized;
      })
      .catch((error) => {
        console.error('Error fetching USSD data:', error);
        handleNotification(`Failed to fetch USSD for ${gatewayId}: ${error.message}`, 'error');
        return [];
      })
      .finally(() => {
        if (!silent) {
          setUssdLoading(false);
        }
      });
  };

  const fetchData = () => {
    const mediaUrl = `${baseUrl}/monitor-media/${selectedGateway}`;
    const callUrl = `${baseUrl}/monitor-call/${selectedGateway}`;
    const sipUrl = `${baseUrl}/monitor-sip/${selectedGateway}`;
    const smsPortUrl = `${baseUrl}/monitor-port/${selectedGateway}`;


    Promise.all([
      fetch(mediaUrl).then(response => response.json()),
      fetch(callUrl).then(response => response.json()),
      fetch(sipUrl).then(response => response.json()),
      fetch(smsPortUrl).then(response => response.json()),

    ]).then(([mediaData, callData, sipData, portData]) => {
      console.log('Fetched mediaData:', mediaData);
      console.log('Fetched callData:', callData);
      console.log('Fetched sipData:', sipData);
      console.log('Fetched portData:', portData);


      setMediaStats(normalizePorts(mediaData));
      setCallStats(normalizePorts(callData));
      setSipStats(normalizePorts(sipData));
      setPortStats(normalizePorts(portData));

    }).catch(error => {
      console.error('Error fetching data:', error);
      handleNotification(`Failed to fetch data for ${selectedGateway}: ${error.message}`);
    });
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 3000); // Fetch every 1 second

    return () => clearInterval(interval);
  }, [selectedGateway]);


  useEffect(() => {
    const newPrevTxPackets = {};
    const newPrevRxPackets = {};

    mediaStats.forEach(mediaStat => {
      const port = mediaStat.Port;
      const currentTxPkts = mediaStat['Packets Sent'];
      const currentRxPkts = mediaStat['Packets Received'];

      const prevTxPkts = prevTxPackets[port] || 0;
      const prevRxPkts = prevRxPackets[port] || 0;

      // Determine txPktColor and rxPktColor based on packet changes
      const newTxPktColor = currentTxPkts > prevTxPkts ? 'green' : currentTxPkts < prevTxPkts ? 'red' : 'inherit';
      const newRxPktColor = currentRxPkts > prevRxPkts ? 'green' : currentRxPkts < prevRxPkts ? 'red' : 'inherit';

      // Set the new colors
      setTxPktColor(prevColors => ({
        ...prevColors,
        [port]: newTxPktColor
      }));
      setRxPktColor(prevColors => ({
        ...prevColors,
        [port]: newRxPktColor
      }));

      // Clear any existing timeouts before setting new ones
      if (txTimeoutRef.current[port]) {
        clearTimeout(txTimeoutRef.current[port]);
      }
      if (rxTimeoutRef.current[port]) {
        clearTimeout(rxTimeoutRef.current[port]);
      }

      // Reset the colors to black after 3 seconds
      txTimeoutRef.current[port] = setTimeout(() => {
        setTxPktColor(prevColors => ({
          ...prevColors,
          [port]: 'inherit'
        }));
      }, 1000);

      rxTimeoutRef.current[port] = setTimeout(() => {
        setRxPktColor(prevColors => ({
          ...prevColors,
          [port]: 'inherit'
        }));
      }, 1000);

      // Save the current packet counts for the next update
      newPrevTxPackets[port] = currentTxPkts;
      newPrevRxPackets[port] = currentRxPkts;
    });

    setPrevTxPackets(newPrevTxPackets);
    setPrevRxPackets(newPrevRxPackets);
  }, [mediaStats]);

  const imeiSmsOperations = [
    { key: 'change-imei', label: 'C IMEI (All)' },
    { key: 'change-imei-no-sim', label: 'C IMEI (N-ALL)' },
    { key: 'enable-sms', label: 'Enable SMS' },
    { key: 'disable-sms', label: 'Disable SMS' },
    { key: 'send-ussd', label: 'Send USSD' },
    { key: 'both-on', label: 'Both Locker ON' },
    { key: 'on-sms-locker', label: 'SMS Locker ON' },
    { key: 'on-call-locker', label: 'Call Locker ON' },
    { key: 'both-off', label: 'Both Locker OFF' },
    { key: 'sms-auto-on', label: 'SMS Auto Test On' },
    { key: 'sms-auto-off', label: 'SMS Auto Test Off' },
    { key: 'update-cookie', label: 'Update Cookie' },
    { key: 'save-config', label: 'Save Config' },  // New operation for saving configurations
    { key: 'reboot-gateway', label: 'Reboot Gateway' }  // New operation for rebooting the gateway
  ];



  const sipOptions = [
    { key: '-0', label: 'Off Traffic' },
    { key: '0', label: 'Empty Account' },
    { key: '1', label: 'NCLI Route On' },
    { key: '1a', label: 'NCLI Route Accounts' },
    { key: 'CC1', label: 'CC1 On(E)' },
    { key: 'CC1A', label: 'CC1 Accounts(E)' },
    { key: 'CC2', label: 'CC2 On(Ea)' },
    { key: 'CC2A', label: 'CC2 Accounts(Ea)' },
    { key: 'CC3', label: 'CC3 On(F)' },
    { key: 'CC3A', label: 'CC3 Accounts(F)' },
    { key: 'CC4', label: 'CC4 On(Fa)' },
    { key: 'CC4A', label: 'CC4 Accounts(Fa)' },
    { key: 'CC5', label: 'CC5 On(Eb)' },
    { key: 'CC5A', label: 'CC5 Accounts(Eb)' },
    { key: 'CC6', label: 'CC6 On(Fb)' },
    { key: 'CC6A', label: 'CC6 Accounts(Fb)' },
    { key: 'CC7', label: 'CC7 On(Fc)' },
    { key: 'CC7A', label: 'CC7 Accounts(Fc)' },
    { key: 'CC8', label: 'CC8 On(Ec)' },
    { key: 'CC8A', label: 'CC8 Accounts(Ec)' },
    { key: 'CC9', label: 'CC9 On(Ed)' },
    { key: 'CC9A', label: 'CC9 Accounts(Ed)' },
    { key: 'CC10', label: 'CC10 On(Fd)' },
    { key: 'CC10A', label: 'CC10 Accounts(Fd)' },
    { key: 'CC11', label: 'CC11 On(Ee)' },
    { key: 'CC11A', label: 'CC11 Accounts(Ee)' },
    { key: 'CC12', label: 'CC12 On(Fe)' },
    { key: 'CC12A', label: 'CC12 Accounts(Fe)' },
    { key: 'CC13', label: 'CC13 On(Ef)' },
    { key: 'CC13A', label: 'CC13 Accounts(Ef)' },
    { key: 'CC14', label: 'CC14 On(Ff)' },
    { key: 'CC14A', label: 'CC14 Accounts(Ff)' },

  ];


  const handlePortCheckbox = (port) => {
    setSelectedPorts((prevSelected) => {
      if (prevSelected.includes(port)) {
        // If already selected, remove it
        return prevSelected.filter(p => p !== port);
      } else {
        // Otherwise, add it
        return [...prevSelected, port];
      }
    });
  };


  {/* { key: 'maizeonncli', label: 'MZ On' },
    { key: 'maizeaccncli', label: 'MZ Accounts' },
    { key: '517', label: 'SK 517' },
    { key: '518', label: 'SK 518' }, */}

  const tips = {
    'g1': 'This is NCLI Route',
    'g2': 'This is NCLI Route',
    'g3': 'This is CC Route',
    'g4': 'This is CC Route',
    'g5': 'This is SK Route',
    'g6': 'This is SK Route'
  };

  useEffect(() => {
    document.title = 'Goip Management Local';
  }, []);

  useEffect(() => {
    localStorage.setItem('selectedGateway', selectedGateway);
  }, [selectedGateway]);

  const handleOperationExecute = (gatewayId, action) => {
    const url = `${baseUrl}/${action}/${gatewayId}`;
    fetchAndAlert(url, gatewayId);
  };

  const handleConfigureSIP = (gatewayId, option) => {
    const url = `${baseUrl}/configure-sip/${gatewayId}/${option}`;
    fetchAndAlert(url, gatewayId);
  };

  const fetchAndAlert = (url, gatewayId) => {
    fetch(url)
      .then(response => response.text())
      .then(data => {
        console.log(data);
        handleNotification(`Response from ${gatewayId}: ${data}`);
      })
      .catch(error => {
        console.error('Error:', error);
        alert(`Failed to perform action for ${gatewayId}`);
      });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      // Select every port from 1 to 32
      setSelectedPorts(Array.from({ length: 32 }, (_, i) => i + 1));
    } else {
      // Unselect all
      setSelectedPorts([]);
    }
  };

  const handleSelectAllUssd = (checked) => {
    if (checked) {
      setSelectedUssdPorts(ussdStats.map((item) => item.Port));
      return;
    }

    setSelectedUssdPorts([]);
  };

  const handleUssdPortCheckbox = (port) => {
    setSelectedUssdPorts((prevSelected) => (
      prevSelected.includes(port)
        ? prevSelected.filter((value) => value !== port)
        : [...prevSelected, port]
    ));
  };

  const handleOpenUssdDialog = () => {
    setOpenUssdDialog(true);
  };

  const handleCloseUssdDialog = () => {
    setOpenUssdDialog(false);
  };

  const handleUssdCommandChange = (port, value) => {
    setUssdStats((prevStats) => prevStats.map((item) => (
      item.Port === port
        ? { ...item, Command: value }
        : item
    )));
  };

  const handleApplyOverallUssdCommand = () => {
    const command = ussdGlobalCommand.trim();
    if (!command) {
      handleNotification('Enter an overall USSD command first.', 'error');
      return;
    }

    setUssdStats((prevStats) => prevStats.map((item) => (
      selectedUssdPorts.includes(item.Port)
        ? { ...item, Command: command }
        : item
    )));
  };

  const closeUssdConfirmDialog = () => {
    setUssdConfirmState({
      open: false,
      mode: 'bulk',
      gatewayId: '',
      port: null,
      ports: [],
      commandPreview: '',
    });
  };

  const executeClearUssd = (gatewayId) => {
    setUssdClearing(true);
    fetch(`${baseUrl}/send_ussd/${gatewayId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        command: 'clear',
        target: 'goip_ussd',
        ports: '-1',
        ussd_cmd: '',
        goip_show_all: '0'
      })
    })
      .then((response) => response.json())
      .then((data) => {
        handleNotification(
          data.message || data.error || 'USSD data cleared.',
          data.error ? 'error' : 'success'
        );
        if (!data.error) {
          return fetchUssdData(gatewayId, { silent: true });
        }
        return null;
      })
      .catch((error) => {
        console.error('Error clearing USSD data:', error);
        handleNotification(`Failed to clear USSD data for ${gatewayId}: ${error.message}`, 'error');
      })
      .finally(() => {
        setUssdClearing(false);
      });
  };

  const executeSendUSSD = (gatewayId, rowsToSend, commands) => {
    const url = `${baseUrl}/send_ussd/${gatewayId}`;
    const payload = {
      ports: rowsToSend.map((item) => item.Port).join(','),
      ussd_cmd: commands.join(','),
      goip_show_all: '0'
    };

    setUssdSubmitting(true);
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        handleNotification(`USSD Command Response: ${data.message || data.error || 'Completed'}`, data.error ? 'error' : 'success');
      })
      .catch(error => {
        console.error('Error sending USSD command:', error);
        handleNotification(`Failed to send USSD command for ${gatewayId}: ${error.message}`, 'error');
      })
      .finally(() => {
        setUssdSubmitting(false);
      });
  };

  const executeSendSingleUssd = (gatewayId, port, command) => {
    setUssdSubmitting(true);
    fetch(`${baseUrl}/send_ussd/${gatewayId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ports: String(port),
        ussd_cmd: command,
        goip_show_all: '0'
      })
    })
      .then((response) => response.json())
      .then((data) => {
        handleNotification(
          `Port ${port}: ${data.message || data.error || 'Completed'}`,
          data.error ? 'error' : 'success'
        );
        setUssdStats((prevStats) => prevStats.map((item) => (
          item.Port === port
            ? { ...item, Command: command, Status: 'pending' }
            : item
        )));
      })
      .catch((error) => {
        console.error('Error sending single USSD command:', error);
        handleNotification(`Failed to send USSD for port ${port}: ${error.message}`, 'error');
      })
      .finally(() => {
        setUssdSubmitting(false);
      });
  };

  const handleConfirmUssdSend = () => {
    const { mode, gatewayId, port } = ussdConfirmState;

    if (mode === 'clear') {
      closeUssdConfirmDialog();
      executeClearUssd(gatewayId);
      return;
    }

    if (mode === 'single' && port != null) {
      const targetRow = ussdStats.find((item) => item.Port === port);
      const command = ussdGlobalCommand.trim() || targetRow?.Command?.trim() || '';
      closeUssdConfirmDialog();
      executeSendSingleUssd(gatewayId, port, command);
      return;
    }

    const rowsToSend = ussdStats
      .filter((item) => selectedUssdPorts.includes(item.Port))
      .sort((a, b) => a.Port - b.Port);
    const overallCommand = ussdGlobalCommand.trim();
    const commands = rowsToSend.map((item) => overallCommand || item.Command?.trim() || '');

    closeUssdConfirmDialog();
    executeSendUSSD(gatewayId, rowsToSend, commands);
  };

  const handleClearUssd = (gatewayId) => {
    setUssdConfirmState({
      open: true,
      mode: 'clear',
      gatewayId,
      port: null,
      ports: [],
      commandPreview: '',
    });
  };


  const handleSendUSSD = (gatewayId) => {
    const rowsToSend = ussdStats
      .filter((item) => selectedUssdPorts.includes(item.Port))
      .sort((a, b) => a.Port - b.Port);

    if (rowsToSend.length === 0) {
      handleNotification('Select at least one USSD port.', 'error');
      return;
    }

    const overallCommand = ussdGlobalCommand.trim();
    const commands = rowsToSend.map((item) => overallCommand || item.Command?.trim() || '');

    if (commands.some((command) => !command)) {
      handleNotification('Each selected port needs a command, or fill the overall command.', 'error');
      return;
    }

    setUssdConfirmState({
      open: true,
      mode: 'bulk',
      gatewayId,
      port: null,
      ports: rowsToSend.map((item) => item.Port),
      commandPreview: overallCommand || commands[0] || '',
    });
  };

  const handleSendSingleUssd = (gatewayId, port) => {
    const targetRow = ussdStats.find((item) => item.Port === port);
    const command = ussdGlobalCommand.trim() || targetRow?.Command?.trim() || '';

    if (!command) {
      handleNotification(`Port ${port} has no USSD command.`, 'error');
      return;
    }

    setUssdConfirmState({
      open: true,
      mode: 'single',
      gatewayId,
      port,
      ports: [port],
      commandPreview: command,
    });
  };

  const handleFetchStatus = (gatewayId) => {
    fetchData();
  };

  const handleRefetchStatus = (gatewayId) => {
    handleFetchStatus(gatewayId);
  };

  const handleChange = (event) => {
    setSelectedGateway(event.target.value);
  };

  const handleNotification = (message, severity = 'success') => {
    const normalizedMessage = String(message ?? '')
      .replace(/\s+/g, ' ')
      .trim();
    const limitedMessage =
      normalizedMessage.length > 220
        ? `${normalizedMessage.slice(0, 217)}...`
        : normalizedMessage;
    showNotification(limitedMessage, severity);
  };

  const handleUpdateCookies = (gatewayId) => {
    const url = `https://frek.cc/proxy/38.54.86.24:7687/update-local-cookies/${gatewayId}`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        console.log('Cookies updated:', data);
        handleNotification(`Cookies updated successfully for ${gatewayId}`);
      })
      .catch(error => {
        console.error('Error updating cookies:', error);
        handleNotification(`Failed to update cookies for ${gatewayId}`);
      });
  };

  const executeSaveOrReboot = (gatewayId, operation) => {
    const url = `https://frek.cc/proxy/38.54.86.24:7687/${operation}/${gatewayId}`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Server returned ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        console.log(`${operation} operation response:`, data);
        handleNotification(`${operation.charAt(0).toUpperCase() + operation.slice(1)} operation executed successfully for ${gatewayId}`);
      })
      .catch(error => {
        console.error(`Error during ${operation} operation:`, error);
        handleNotification(`Failed to ${operation} ${gatewayId}`);
      });
  };

  const [selectedOperation, setSelectedOperation] = useState('');
  const [selectedOption, setSelectedOption] = useState('');

  const handleOperationChange = (event) => {
    setSelectedOperation(event.target.value);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleExecute = () => {
    switch (selectedOperation) {
      case 'send-ussd':
        handleOpenUssdDialog();
        break;
      case 'update-cookie':
        handleUpdateCookies(selectedGateway);
        break;
      case 'save-config':
        executeSaveOrReboot(selectedGateway, 'save');
        break;
      case 'reboot-gateway':
        executeSaveOrReboot(selectedGateway, 'reboot');
        break;
      default:
        handleOperationExecute(selectedGateway, selectedOperation);
        break;
    }
  };

  const handleConfigure = () => {
    handleConfigureSIP(selectedGateway, selectedOption);
  };

  useEffect(() => {
    handleFetchStatus(selectedGateway);
  }, [selectedGateway]);


  const statusMapping = {
    CONNECTED: '✔',
    HANGUP: '✕',
    ALERTING: '⟹',
    DISCONNECTED: '★',
    DIALING: '►'
  };

  const handlePerformActions = async () => {
    setOpenConfirmDialog(false);
    setOperationInProgress(true);

    const actions = [
      { key: 'configure-sip', option: '-0' }, // Off Traffic (Global)
      { key: 'configure-sip', option: '0' },  // Empty Account (Global)
      { key: 'change-imei', option: 'change-imei' },
      { key: 'disable-sms', option: 'disable-sms' },
      { key: 'on-sms-locker', option: 'on-sms-locker' },
      { key: 'save-config', option: 'save' },
      { key: 'reboot-gateway', option: 'reboot' }
    ];

    for (let action of actions) {
      await performAction(selectedGateway, action.key, action.option);
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 2 seconds
    }

    setOperationInProgress(false);
  };

  const performAction = async (gatewayId, action, option) => {
    let url;
    let options = {};

    // Set up URL and request options based on the action type
    if (action === 'configure-sip') {
      url = `${baseUrl}/configure-sip/${gatewayId}/${option}`;
      options.method = 'GET';
    } else if (action === 'save-config' || action === 'reboot-gateway') {
      url = `${baseUrl}/${option}/${gatewayId}`;
      options.method = 'POST';
      options.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };
    } else {
      url = `${baseUrl}/${action}/${gatewayId}`;
      options.method = 'GET';
    }

    try {
      const response = await fetch(url, options);

      // Check if the response is JSON or plain text and handle accordingly
      const contentType = response.headers.get("content-type");
      let data;
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();  // Parsing JSON response
      } else {
        data = await response.text();  // Parsing plain text response
      }

      // Depending on the data type, display the appropriate notification
      if (typeof data === 'string') {
        handleNotification(`Response from ${gatewayId}: ${data}`);
      } else {
        handleNotification(`Response from ${gatewayId}: ${data.message || data.error || JSON.stringify(data)}`);
      }
    } catch (error) {
      console.error('Error:', error);
      handleNotification(`Failed to perform action for ${gatewayId}`);
    }
  };

  const metricColumns = useMemo(
    () => [
      { label: 'D', key: 'Calls' },
      { label: 'A', key: 'Alerted' },
      { label: 'C', key: 'Connected' },
      { label: 'CF', key: 'ConFail' },
      { label: 'ACD', key: 'ACD' },
      { label: 'ASR', key: 'ASR' },
    ],
    []
  );

  const metricWidths = useMemo(
    () =>
      metricColumns.map(({ label, key }) => {
        const maxDataLen = callStats.reduce((maxLen, stat) => {
          const raw = stat?.[key];
          const value = raw === 0 ? '0' : raw || '-';
          return Math.max(maxLen, String(value).length);
        }, 1);
        return Math.max(label.length, maxDataLen);
      }),
    [callStats, metricColumns]
  );

  const formatMetricLine = (stat, isHeader = false) =>
    metricColumns
      .map((column, idx) => {
        const raw = isHeader ? column.label : stat?.[column.key];
        const value = raw === 0 ? '0' : raw || '-';
        return String(value).padStart(metricWidths[idx], ' ');
      })
      .join(' | ');

  const metricTextSx = {
    fontFamily: 'Consolas, "Courier New", monospace',
    whiteSpace: 'pre',
    fontVariantNumeric: 'tabular-nums',
  };

  const stickyPortHeaderSx = isMobile
    ? {
        position: 'sticky',
        left: 0,
        zIndex: 7,
        backgroundColor: 'rgba(20, 20, 26, 0.98)',
        boxShadow: '2px 0 0 rgba(255,255,255,0.08)',
      }
    : {};

  const stickyPortCellSx = isMobile
    ? {
        position: 'sticky',
        left: 0,
        zIndex: 4,
        backgroundColor: 'rgba(18, 18, 22, 0.96)',
        boxShadow: '2px 0 0 rgba(255,255,255,0.06)',
      }
    : {};


  return (
    <ThemeProvider theme={darkTheme}>
      {/* 2. Use CssBaseline to get consistent dark styles (optional) */}
      <CssBaseline />

      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          overflowX: 'hidden',
          background:
            'radial-gradient(1200px 600px at 15% -10%, rgba(78, 118, 255, 0.28), transparent 60%),' +
            'radial-gradient(900px 600px at 110% 10%, rgba(0, 200, 170, 0.22), transparent 55%),' +
            'linear-gradient(180deg, #0b0b10 0%, #101018 45%, #0d0f12 100%)',
          color: '#e8e9ee',
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={2.5}>


            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 3,
                background: 'rgba(18, 18, 22, 0.75)',
                border: '1px solid rgba(255,255,255,0.06)',
                backdropFilter: 'blur(6px)',
              }}
            >
              

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  spacing={1.5}
                  alignItems="stretch"
                >
                  <Box
                    sx={{
                      flex: 1,
                      p: 1,
                      borderRadius: 2,
                      border: '1px solid rgba(255,255,255,0.06)',
                      background: 'rgba(13, 14, 18, 0.8)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap',
                      width: { xs: '100%', md: 'auto' },
                    }}
                  >
                    <Select
                      value={selectedGateway}
                      onChange={handleChange}
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        height: '2rem',
                        minWidth: { xs: 80, sm: 90 },
                      }}
                      size="small"
                      displayEmpty
                    >
                      {gateways.map((gateway) => (
                        <MenuItem key={gateway} value={gateway}>
                          {` G${gateway.substring(1).toUpperCase()}`}
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      variant="contained"
                      onClick={() => setOpenConfirmDialog(true)}
                      sx={{
                        fontSize: '0.875rem',
                        height: '2rem',
                        backgroundColor: 'error.main',
                        color: '#fff',
                        '&:hover': {
                          backgroundColor: '#b71c1c',
                        },
                      }}
                    >
                      Reboot
                    </Button>

                    <Button
                      variant="contained"
                      onClick={handleSubmitPorts}
                      sx={{ fontSize: '0.875rem', height: '2rem' }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleOpenUssdDialog}
                      sx={{ fontSize: '0.875rem', height: '2rem' }}
                    >
                      USSD
                    </Button>


                    <Dialog
                      open={openConfirmDialog}
                      onClose={() => setOpenConfirmDialog(false)}
                    >
                      <DialogTitle>
                        Confirm Restart of G{selectedGateway.substring(1).toUpperCase()}
                      </DialogTitle>
                      <DialogContent>
                        <Typography>
                          Are you sure you want to restart G
                          {selectedGateway.substring(1).toUpperCase()}?
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setOpenConfirmDialog(false)}>Cancel</Button>
                        <Button onClick={handlePerformActions}>Yes</Button>
                      </DialogActions>
                    </Dialog>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      p: 1,
                      borderRadius: 2,
                      border: '1px solid rgba(255,255,255,0.06)',
                      background: 'rgba(13, 14, 18, 0.8)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap',
                      width: { xs: '100%', md: 'auto' },
                    }}
                  >
                    <Select
                      value={selectedOperation}
                      onChange={handleOperationChange}
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        height: '2rem',
                        minWidth: { xs: 150, sm: 180 },
                      }}
                      size="small"
                    >
                      {imeiSmsOperations.map((operation) => (
                        <MenuItem key={operation.key} value={operation.key}>
                          {operation.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      variant="contained"
                      onClick={handleExecute}
                      sx={{ fontSize: '0.875rem', height: '2rem' }}
                    >
                      Execute
                    </Button>

                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      p: 1,
                      borderRadius: 2,
                      border: '1px solid rgba(255,255,255,0.06)',
                      background: 'rgba(13, 14, 18, 0.8)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap',
                      width: { xs: '100%', md: 'auto' },
                    }}
                  >
                    <Select
                      value={selectedOption}
                      onChange={handleOptionChange}
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        height: '2rem',
                        minWidth: { xs: 170, sm: 200 },
                      }}
                      size="small"
                    >
                      {sipOptions.map((option) => (
                        <MenuItem key={option.key} value={option.key}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      variant="contained"
                      onClick={handleConfigure}
                      sx={{ fontSize: '0.875rem', height: '2rem' }}
                    >
                      Apply SIP
                    </Button>


                  </Box>
                </Stack>
             
            </Paper>

            {/* Main Table */}
            <TableContainer
              component={Paper}
              sx={{
                background: 'rgba(18, 18, 22, 0.75)',
                border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: 3,
                backdropFilter: 'blur(6px)',
                overflowX: 'auto',
              }}
            >
              <Table
                sx={{
                  color: 'text.primary',
                  '& td, & th': {
                    textAlign: 'center',
                    py: 0.08,
                    px: 0.3,
                    lineHeight: 1,
                    height: 22,
                  },
                  '& thead th': {
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    color: 'rgba(255,255,255,0.7)',
                  },
                  minWidth: 860,
                }}
                size="small"
              >
                <TableHead>
                  <TableRow>

                    <TableCell
                      sx={{
                        fontSize: { xs: 11, sm: 13, md: 15 },
                        fontWeight: 'bold', // or normal
                        px: { xs: 0.25, sm: 0.55 },
                      }}

                    >
                      <Tooltip title="If Green Means SIP is OK">
                        <span>Account</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: { xs: 11, sm: 13, md: 15 },
                        fontWeight: 'bold',
                        px: { xs: 0.25, sm: 0.55 },
                        ...stickyPortHeaderSx,
                      }}
                    >
                      <Tooltip title="If Green Means SMS is Enabled Else Disabled">
                        <span>Port</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      <Tooltip title="CONNECTED: '✔' HANGUP: '✕' ALERTING: '⟹'   DISCONNECTED: '★' DIALING: '►'">
                        <span>Call</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      Time
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      Description
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      <Tooltip title="D: Calls | A: Alerted | C: Connected | CF: Consecutive Failed Calls | ACD: Actual Call Duration | ASR: Answer Seizure Ratio">
                        <Box component="span" sx={metricTextSx}>
                          {formatMetricLine(null, true)}
                        </Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      <Checkbox
                        checked={selectedPorts.length === 32} // or check if all are selected
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, fontWeight: 'bold', px: { xs: 0.25, sm: 0.55 } }}>
                      Act
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {mediaStats.map((mediaStat, index) => {
                    const port = mediaStat.Port;
                    const callStat =
                      callStats.find((stat) => stat.Port === port) || {};
                    const sipStat =
                      sipStats.find((stat) => stat.Port === port) || {};
                    const portStat =
                      portStats.find((stat) => stat.Port === port) || {};
                    // const ussdStat =
                    //   ussdStats.find((stat) => stat.Port === port) || {};

                    // Example color logic
                    const portColor =
                      portStat.Status === '√' ? 'green' : 'inherit';
                    const accountColor =
                      sipStat.Status === 'Ready' ? 'green' : 'inherit';

                    // Check if this port is in selectedPorts
                    const isSelected = selectedPorts.includes(port);

                    return (
                      <TableRow
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                          },
                        }}
                      >

   
                        {/* Account */}
                        <TableCell
                          sx={{
                            fontSize: { xs: 11, sm: 13, md: 15 },
                            color: accountColor,
                            px: { xs: 0.25, sm: 0.55 },
                          }}
                        >
                          {sipStat.Account}
                        </TableCell>

                        {/* Port */}
                        <TableCell
                          sx={{
                            fontSize: { xs: 11, sm: 13, md: 15 },
                            color: portColor,
                            px: { xs: 0.25, sm: 0.55 },
                            ...stickyPortCellSx,
                          }}
                        >
                          {port}
                        </TableCell>



                        {/* Call Status */}
                        <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, px: { xs: 0.25, sm: 0.55 } }}>
                          {statusMapping[callStat['Call-Status']] || '-'}
                        </TableCell>

                        {/* Time */}
                        <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, px: { xs: 0.25, sm: 0.55 } }}>
                          {callStat['Time'] || '-'}
                        </TableCell>


                        {/* Time */}
                        <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, px: { xs: 0.25, sm: 0.55 } }}>
                          {callStat['Description'] || '-'}
                        </TableCell>

                        <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, px: { xs: 0.25, sm: 0.55 } }}>
                          <Box component="span" sx={metricTextSx}>
                            {formatMetricLine(callStat)}
                          </Box>
                        </TableCell>
                     <TableCell sx={{ px: { xs: 0.25, sm: 0.55 } }}>
                          <Checkbox
                            checked={isSelected}
                            onChange={() => handlePortCheckbox(port)}
                            sx={{
                              width: "16px",
                              height: "16px",
                              transform: "scale(0.8)"
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: 11, sm: 13, md: 15 }, px: { xs: 0.25, sm: 0.55 } }}>
                          <Tooltip title={`Restart port ${port}`}>
                            <IconButton
                              color="warning"
                              size="small"
                              onClick={() => handleShowPortRestartDialog(port)}
                              sx={{
                                p: 0.15,
                              }}
                            >
                              <RestartAltIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>


        <Dialog
          open={openPortRestartDialog}
          onClose={() => setOpenPortRestartDialog(false)}
        >
          <DialogTitle>Restart Port {portToRestart}?</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to restart port #{portToRestart}?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPortRestartDialog(false)}>Cancel</Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmPortRestart}
            >
              Restart
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openUssdDialog}
          onClose={handleCloseUssdDialog}
          fullWidth
          fullScreen={isMobile}
          maxWidth="xl"
          PaperProps={{
            sx: {
              width: { xs: '100%', sm: 'min(1400px, calc(100vw - 32px))' },
              maxWidth: '100%',
              m: { xs: 0, sm: 2 },
            },
          }}
        >
          <DialogTitle>
            USSD Manager - G{selectedGateway.substring(1).toUpperCase()}
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: { xs: '100%', md: '78vh' },
              overflow: 'hidden',
              px: { xs: 1, sm: 2 },
              py: { xs: 1, sm: 1.5 },
            }}
          >
            <Stack spacing={1.25} sx={{ flex: 1, minHeight: 0 }}>
              <Box
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 2,
                  backgroundColor: 'background.paper',
                  pb: 0.5,
                  mx: { xs: -0.5, sm: 0 },
                  px: { xs: 0.5, sm: 0 },
                }}
              >
                <Stack spacing={1.25}>
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    flexWrap="wrap"
                  >
                    <TextField
                      label="Overall Command"
                      value={ussdGlobalCommand}
                      onChange={(event) => setUssdGlobalCommand(event.target.value)}
                      placeholder="*123*6*2# then response 1 for 3x"
                      size="small"
                      fullWidth
                      sx={{
                        flex: { xs: '0 1 170px', md: '0 1 170px' },
                        minWidth: 0,
                        width: { xs: 'min(100%, 170px)', md: 170 },
                        maxWidth: 170,
                      }}
                    />
                    <Stack
                      direction="row"
                      spacing={0.5}
                      alignItems="center"
                      sx={{
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        width: 'auto',
                        flexShrink: 0,
                      }}
                    >
                      <Tooltip title="Apply overall command to selected ports">
                        <span>
                          <IconButton
                            color="primary"
                            onClick={handleApplyOverallUssdCommand}
                            size="small"
                            sx={{ p: { xs: 0.75, sm: 1 } }}
                          >
                            <DoneAllRoundedIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Refresh USSD data">
                        <span>
                          <IconButton
                            color="primary"
                            onClick={() => fetchUssdData(selectedGateway)}
                            disabled={ussdLoading}
                            size="small"
                            sx={{ p: { xs: 0.75, sm: 1 } }}
                          >
                            <RefreshRoundedIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Clear USSD data">
                        <span>
                          <IconButton
                            color="warning"
                            onClick={() => handleClearUssd(selectedGateway)}
                            disabled={ussdClearing || ussdSubmitting}
                            size="small"
                            sx={{ p: { xs: 0.75, sm: 1 } }}
                          >
                            <RestartAltIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Send USSD to selected ports">
                        <span>
                          <IconButton
                            color="secondary"
                            onClick={() => handleSendUSSD(selectedGateway)}
                            disabled={ussdSubmitting || ussdLoading}
                            size="small"
                            sx={{ p: { xs: 0.75, sm: 1 } }}
                          >
                            <SendRoundedIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Stack>
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={1}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    justifyContent="space-between"
                  >
                    <Typography variant="caption" color="text.secondary">
                      Selected ports: {selectedUssdPorts.length}
                    </Typography>
                    <FormControlLabel
                      control={(
                        <Switch
                          size="small"
                          checked={showAllUssdResponses}
                          onChange={(event) => setShowAllUssdResponses(event.target.checked)}
                        />
                      )}
                      label="Show all responses"
                      sx={{
                        m: 0,
                        mr: 0,
                        '& .MuiFormControlLabel-label': {
                          fontSize: { xs: 12, sm: 14 },
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              </Box>

              <TableContainer
                component={Paper}
                variant="outlined"
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflow: 'auto',
                  overflowX: 'auto',
                  borderRadius: { xs: 1, sm: 1.5 },
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  sx={{
                    minWidth: { xs: 700, sm: 860 },
                    '& td, & th': {
                      py: { xs: 0.4, sm: 0.45 },
                      px: { xs: 0.55, sm: 0.75 },
                      fontSize: { xs: 11, sm: 12.5 },
                    },
                    '& .MuiTableCell-head': {
                      backgroundColor: 'background.paper',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={ussdStats.length > 0 && selectedUssdPorts.length === ussdStats.length}
                          indeterminate={selectedUssdPorts.length > 0 && selectedUssdPorts.length < ussdStats.length}
                          onChange={(event) => handleSelectAllUssd(event.target.checked)}
                        />
                      </TableCell>
                      <TableCell>Port</TableCell>
                      <TableCell sx={{ minWidth: { xs: 132, md: 168 }, width: { xs: 132, md: 168 } }}>Command</TableCell>
                      <TableCell sx={{ minWidth: 320 }}>Response</TableCell>
                      <TableCell sx={{ minWidth: 90 }}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ussdStats.map((row) => (
                      <TableRow key={row.Port} hover>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedUssdPorts.includes(row.Port)}
                            onChange={() => handleUssdPortCheckbox(row.Port)}
                          />
                        </TableCell>
                        <TableCell>{row.Port}</TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={0.5} alignItems="center" sx={{ width: 'fit-content' }}>
                            <TextField
                              value={row.Command || ''}
                              onChange={(event) => handleUssdCommandChange(row.Port, event.target.value)}
                              size="small"
                              fullWidth
                              sx={{ width: { xs: 82, md: 120 } }}
                              inputProps={{ style: { padding: '6px 8px', fontSize: isMobile ? 12 : 13 } }}
                            />
                            <Tooltip title={`Send USSD for port ${row.Port}`}>
                              <span>
                                <IconButton
                                  color="secondary"
                                  size="small"
                                  onClick={() => handleSendSingleUssd(selectedGateway, row.Port)}
                                  disabled={ussdSubmitting}
                                  sx={{ p: 0.5 }}
                                >
                                  <SendRoundedIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Tooltip
                            title={<Box sx={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>{row.Response || '-'}</Box>}
                            placement="top-start"
                            arrow
                          >
                            <Box
                              sx={{
                                whiteSpace: 'pre-wrap',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: showAllUssdResponses ? 'unset' : 2,
                                lineClamp: showAllUssdResponses ? 'unset' : 2,
                                fontSize: { xs: 11, sm: 12 },
                                lineHeight: 1.25,
                                maxHeight: showAllUssdResponses ? 'none' : '2.5em',
                                transition: 'max-height 0.15s ease',
                              }}
                            >
                              {row.Response || '-'}
                            </Box>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={row.Status || '-'}
                            size="small"
                            color={row.Status === 'pending' ? 'warning' : 'success'}
                            variant={row.Status === 'pending' ? 'filled' : 'outlined'}
                            sx={{
                              height: { xs: 18, sm: 20 },
                              '& .MuiChip-label': {
                                px: 0.8,
                                fontSize: { xs: 10, sm: 11 },
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                    {ussdStats.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={5}>
                          <Typography variant="body2" color="text.secondary" align="center">
                            {ussdLoading ? 'Loading USSD data...' : 'No USSD data available.'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseUssdDialog}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={ussdConfirmState.open}
          onClose={closeUssdConfirmDialog}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>
            {ussdConfirmState.mode === 'single'
              ? `Send USSD to Port ${ussdConfirmState.port}?`
              : ussdConfirmState.mode === 'clear'
                ? 'Clear USSD data?'
                : `Send USSD to ${ussdConfirmState.ports.length} selected ports?`}
          </DialogTitle>
          <DialogContent>
            <Stack spacing={1}>
              <Typography variant="body2" color="text.secondary">
                Gateway: G{(ussdConfirmState.gatewayId || selectedGateway).substring(1).toUpperCase()}
              </Typography>
              <Typography variant="body2">
                {ussdConfirmState.mode === 'single'
                  ? `This will send the command to port ${ussdConfirmState.port}.`
                  : ussdConfirmState.mode === 'clear'
                    ? 'This will clear the current USSD data on the gateway.'
                  : `This will send the command to ports ${ussdConfirmState.ports.join(', ')}.`}
              </Typography>
              {ussdConfirmState.mode !== 'clear' && (
                <>
                  <Typography variant="body2" color="text.secondary">
                    Command preview:
                  </Typography>
                  <Box
                    sx={{
                      px: 1,
                      py: 0.75,
                      borderRadius: 1,
                      border: '1px solid',
                      borderColor: 'divider',
                      backgroundColor: 'background.default',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      fontFamily: 'Consolas, "Courier New", monospace',
                      fontSize: 13,
                    }}
                  >
                    {ussdConfirmState.commandPreview || '-'}
                  </Box>
                </>
              )}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeUssdConfirmDialog}>Cancel</Button>
            <Button
              variant="contained"
              color={ussdConfirmState.mode === 'clear' ? 'warning' : 'secondary'}
              onClick={handleConfirmUssdSend}
              disabled={ussdSubmitting || ussdClearing}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>


        {/* Dialog for EIMS Configuration */}
        <Dialog open={openDialog} onClose={handleClose}>
          <DialogTitle>EIMS Configuration</DialogTitle>
          <DialogContent>
            <Select
              value=""
              onChange={handlePrefillChange}
              fullWidth
              margin="dense"
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select Prefill
              </MenuItem>
              {Object.keys(prefillOptions).map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            <Select
              value={formValues.esn_server_type}
              onChange={handleInputChange}
              name="esn_server_type"
              fullWidth
              margin="dense"
            >
              <MenuItem value={0}>Off</MenuItem>
              <MenuItem value={1}>EIMS</MenuItem>
              <MenuItem value={2}>EMDA</MenuItem>
            </Select>
            <TextField
              margin="dense"
              name="esn_server"
              label="Server Address"
              type="text"
              fullWidth
              value={formValues.esn_server}
              onChange={handleInputChange}
            />
            <Select
              value={formValues.esn_ucp_tcp}
              onChange={handleInputChange}
              name="esn_ucp_tcp"
              fullWidth
              margin="dense"
            >
              <MenuItem value={0}>UDP</MenuItem>
              <MenuItem value={1}>TCP</MenuItem>
            </Select>
            <TextField
              margin="dense"
              name="esn_username"
              label="Username"
              type="text"
              fullWidth
              value={formValues.esn_username}
              onChange={handleInputChange}
            />
            <TextField
              margin="dense"
              name="esn_password"
              label="Password"
              type="password"
              fullWidth
              value={formValues.esn_password}
              onChange={handleInputChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleFormSubmit}>Submit</Button>
          </DialogActions>
        </Dialog>
        </Stack>
      </Container>
    </Box>
    </ThemeProvider>
  );
};

export default App;

